exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tab-buttons-header .bi[data-v-7d26c02c]::before {\n    display: inline;\n}\n.draggable-item[data-v-7d26c02c]:active {\n    cursor: grabbing;\n}\n\n\n", ""]);

// exports
